<template>
  <div id="main">
    <Breadcrumbs />
    <Mainmenu />
    <slot />
  </div>
</template>

<script>
  import Breadcrumbs from './Breadcrumbs';
  import Mainmenu from './Mainmenu';

  export default {
    components: {Breadcrumbs, Mainmenu},
  }
</script>

<style>
  #main {
    position: relative;
  }
</style>


// WEBPACK FOOTER //
// src/Layout.vue